if (!customElements.get('olivia-sticky-atc')) {
  customElements.define(
    'olivia-sticky-atc',
    class OliviaStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sourceButton = document.getElementById(this.dataset.sourceId);
        this.stickyButton = this.querySelector('button');

        if (!this.sourceButton || !this.stickyButton) {
          this.hidden = true;
          return;
        }

        this.syncButtonState();
        this.stickyButton.addEventListener('click', () => this.sourceButton.click());

        this.buttonObserver = new MutationObserver(() => this.syncButtonState());
        this.buttonObserver.observe(this.sourceButton, {
          attributes: true,
          childList: true,
          subtree: true,
        });

        this.visibilityObserver = new IntersectionObserver(
          ([entry]) => this.classList.toggle('is-visible', !entry.isIntersecting),
          { threshold: 0.1 }
        );
        this.visibilityObserver.observe(this.sourceButton);
      }

      disconnectedCallback() {
        this.buttonObserver?.disconnect();
        this.visibilityObserver?.disconnect();
      }

      syncButtonState() {
        const sourceText = this.sourceButton.querySelector('span')?.textContent?.trim();
        const stickyText = this.stickyButton.querySelector('span');

        if (sourceText && stickyText) stickyText.textContent = sourceText;

        this.stickyButton.disabled =
          this.sourceButton.disabled || this.sourceButton.getAttribute('aria-disabled') === 'true';
      }
    }
  );
}
